import taxExempt from './taxExempt';

const partnerProfile = {}

partnerProfile.cellTax = taxExempt

export default partnerProfile
